import axios from 'axios';
import { API } from '@/config/api';

const state = {
    packets: [],
};

const getters = {
    getPackets: (state) => state.packets,
};

const mutations = {
    setPackets: (state, packets) => {
        state.packets = packets;
    },
};

const actions = {
    async fetchPackets({ commit }) {
        try {
            const response = await axios.post(
                API.GET_PACKETS,
                {
                    "token": "test",
                    "limit": 50,
                    "page": 0
                }
            );

            if (response.data.status) {
                commit('setPackets', response.data.response.packet);
            } else {
                
            }
        } catch (error) {
            console.error('Error fetching packet items:', error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
